import { cn } from "@moe/priv/utils";
import { motion } from "motion/react";

interface Props {
  className?: string;
}

export const LoadingSpinner = ({ className }: Props) => (
  <div className={cn("flex items-center justify-center", className)}>
    <motion.div
      className="border-moe-card h-12 w-12 rounded-full border-4 border-t-transparent"
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
    />
  </div>
);
